export default "__VITE_ASSET__8b8f47c1__"